// extracted by extract-css-chunks-webpack-plugin
module.exports = {"previewLimit":"app-components-kit-waveform-previewlimit--previewLimit"};